var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-subtitle-1 primary--text"},[_vm._v(_vm._s(_vm.title))]),_vm._l((Object.entries(_vm.totalAgrupadoPorFormaPagamento)),function(ref){
var key = ref[0];
var value = ref[1];
return _c('div',{key:key,staticClass:"d-flex justify-space-between"},[_c('span',[_vm._v(_vm._s(key))]),_c('span',{class:value >= 0 ? 'positive-value' : 'negative-value'},[_vm._v(_vm._s(_vm.toReal(value)))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }